import React, { useEffect, useState } from 'react';
import { t, Trans } from '@lingui/macro';

import { Grow, Shrink } from '@rover/icons';
import { Button, Flex } from '@rover/kibble/core';
import { ZIndex } from '@rover/kibble/styles';

import ZoomControls from './ZoomControls';

type Props = {
  isExpanded: boolean;
  mapHasMoved: boolean;
  onSearchThisAreaPress: () => void;
  onMapExpanderClick: () => void;
  isSearchLoading?: boolean;
  map: google.maps.Map;
};

export default function MapControlsV2({
  isExpanded,
  mapHasMoved,
  onSearchThisAreaPress,
  onMapExpanderClick,
  isSearchLoading,
  map,
}: Props): JSX.Element {
  const [shouldShowSearchThisArea, setShouldShowSearchThisArea] = useState(false);

  useEffect(() => {
    // We want to continue to show the button while the search results are loading
    if (isSearchLoading || mapHasMoved) {
      setShouldShowSearchThisArea(true);
    } else {
      setShouldShowSearchThisArea(false);
    }
  }, [isSearchLoading, mapHasMoved]);

  return (
    <Flex
      position="absolute"
      justifyContent="space-between"
      alignItems="flex-start"
      zIndex={ZIndex.ONE.toString()}
      top="3x"
      left="5x"
      right="5x"
    >
      <Button
        onClick={onMapExpanderClick}
        circular
        size="small"
        icon={isExpanded ? Shrink : Grow}
        aria-expanded={isExpanded}
        aria-label={isExpanded ? t`Shrink map` : t`Enlarge map`}
        alignSelf="flex-start"
      />
      {shouldShowSearchThisArea && (
        <Button
          size="small"
          contrast
          onClick={onSearchThisAreaPress}
          iconAlignment="right"
          loading={isSearchLoading}
          alignSelf="flex-start"
        >
          <Trans>Search this area</Trans>
        </Button>
      )}
      <ZoomControls map={map} />
    </Flex>
  );
}
